import type { BaseElementDefBase } from "../elements/BaseElementDef";
import TextboxDef from "./TextboxDef.3.vue";
import FileDef from "./FileDef.3.vue";
import CheckGroupDef from "./CheckGroupDef.3.vue";
import RadioGroupDef from "./RadioGroupDef.3.vue";
import CalculatedDef from "./CalculatedDef.3.vue";
import ValidationDef from "./ValidationDef.3.vue";
import DisplayIfOtherHasValueDef from "./DisplayIfOtherHasValueDef.3.vue";
import ForEachDef from "./ForEachDef.3.vue";
import ForEachChildIdDef from "./ForEachChildIdDef.3.vue";
import ForEachChildIndexDef from "./ForEachChildIndexDef.3.vue";
import RegionDef from "./RegionDef.3.vue";
import SectionDef from "./SectionDef.3.vue";
import AddressDef from "./AddressDef.3.vue";
import DatePickerDef from "./DatePickerDef.3.vue";
import ContentDef from "./ContentDef.3.vue";
import DropDownListDef from "./DropDownListDef.3.vue";
import DataTableDef from "./DataTableDef.3.vue";
import LandingPageTemplateDef from "./LandingPageTemplateDef.3.vue";
import ContentTemplatePageDef from "./ContentTemplatePageDef.3.vue";
//import ContactPageTemplateDef from "./ContactPageTemplateDef.3.vue";
import FormAlternativeDef from "./FormAlternativeDef.3.vue";
import LinkAlternativeDef from "./LinkAlternativeDef.3.vue";
import PdfAlternativeDef from "./PdfAlternativeDef.3.vue";
import DisplayElementDef from "./DisplayElementDef.3.vue";
import ReviewPageTemplatePageDef from "./ReviewPageTemplatePageDef.3.vue";
import CommonCheckoutReceiptDef from "./CommonCheckoutReceiptDef.3.vue";
import MspPaymentReceiptDef from "./MspPaymentReceiptDef.3.vue";
import UtGovPayReceiptDef from "./UtGovPayReceiptDef.3.vue";
import PageDef from "./PageDef.3.vue";
import IdVerificationDef from "./IdVerificationDef.3.vue";
import ExtraDataShimDef from "./ExtraDataShimDef.3.vue";

export default function getComponent(element: BaseElementDefBase, display: boolean) {
    const elementType = element.definition.type;
    switch (elementType) {
        case "TextboxDef":
            return TextboxDef;
        case "FileDef":
            return FileDef;
        case "CheckGroupDef":
            return CheckGroupDef;
        case "RadioGroupDef":
            return RadioGroupDef;
        case "CalculatedDef":
            return CalculatedDef;
        case "ValidationDef":
            return ValidationDef;
        case "DisplayIfOtherHasValueDef":
            return DisplayIfOtherHasValueDef;
        case "ForEachDef":
            return ForEachDef;
        case "ForEachChildIdDef":
            return ForEachChildIdDef;
        case "ForEachChildIndexDef":
            return ForEachChildIndexDef;
        case "RegionDef":
            return RegionDef;
        case "SectionDef":
            return SectionDef;
        case "AddressDef":
            return AddressDef;
        case "DatePickerDef":
            return DatePickerDef;
        case "ContentDef":
            return ContentDef;
        case "DropDownListDef":
            return DropDownListDef;
        case "DataTableDef":
            return DataTableDef;
        case "LandingPageTemplateDef":
            return LandingPageTemplateDef;
        case "ContentTemplatePageDef":
            return ContentTemplatePageDef;
        //case "ContactPageTemplateDef":
        //    return ContactPageTemplateDef;
        case "FormAlternativeDef":
            return FormAlternativeDef;
        case "LinkAlternativeDef":
            return LinkAlternativeDef;
        case "PdfAlternativeDef":
            return PdfAlternativeDef;
        case "DisplayElementDef":
            return DisplayElementDef;
        case "ReviewPageTemplatePageDef":
            return ReviewPageTemplatePageDef;
        case "CommonCheckoutReceiptDef":
            return CommonCheckoutReceiptDef;
        case "MspPaymentReceiptDef":
            return MspPaymentReceiptDef;
        case "UtGovPayReceiptDef":
            return UtGovPayReceiptDef;
        case "PageDef":
            return PageDef;
        case "IdVerificationDef":
            return IdVerificationDef;
        case "CaptchaControlDef":
            return null;
        case "ExtraDataShimDef":
            return ExtraDataShimDef;
    }
    throw new Error(`Unknown element type: ${elementType}`);
    console.log(`Unknown element type: ${elementType}`);
    debugger;
    return null;
}
